var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 61,
    viewBox: "0 0 100 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 5.5,
    width: 55,
    height: 28,
    rx: 14,
    transform: "rotate(90 99.5 5.5)",
    fill: "white",
    stroke: "#D0D5DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.8125,
    y: 6.78711,
    width: 25.375,
    height: 25.0213,
    rx: 12.5106,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 17.0518H80.9084C80.2117 17.0518 79.647 17.6174 79.647 18.3152V22.7373C79.647 23.4351 80.2117 24.0008 80.9084 24.0008H89.7386C90.4352 24.0008 91 23.4351 91 22.7373V18.3152C91 17.6174 90.4352 17.0518 89.7386 17.0518Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1694 17.052V14.5251C82.1686 13.7418 82.4585 12.9861 82.9827 12.4048C83.5069 11.8235 84.228 11.458 85.0061 11.3793C85.7842 11.3006 86.5638 11.5142 87.1934 11.9788C87.8231 12.4434 88.258 13.1257 88.4136 13.8934",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6274 44.2734H81.0195C80.2615 44.2734 79.647 44.8211 79.647 45.4967V49.7781C79.647 50.4537 80.2615 51.0013 81.0195 51.0013H90.6274C91.3855 51.0013 92 50.4537 92 49.7781V45.4967C92 44.8211 91.3855 44.2734 90.6274 44.2734Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3916 44.2733V41.8268C82.3907 41.0685 82.7061 40.3368 83.2765 39.774C83.8468 39.2112 84.6315 38.8573 85.4781 38.7811C86.3248 38.7049 87.173 38.9118 87.8581 39.3616C88.5433 39.8114 89.0164 40.472 89.1858 41.2152V44.2733",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.25C31.5 7.82766 24.6723 1 16.25 1C7.82766 1 1 7.82766 1 16.25V44.25C1 52.6723 7.82766 59.5 16.25 59.5C24.6723 59.5 31.5 52.6723 31.5 44.25V16.25Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67285 17.6062C11.536 15.3467 13.884 14.1094 16.3087 14.1094C18.7334 14.1094 21.0814 15.3467 22.9445 17.6062",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30469 12.7361C9.05929 9.2007 12.6053 7.25 16.2773 7.25C19.9494 7.25 23.4953 9.2007 26.25 12.7361",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0029 22.4944C13.9599 21.5045 15.1046 20.9727 16.2784 20.9727C17.4523 20.9727 18.597 21.5045 19.554 22.4944",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 29H1.25",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 44.25C25.5 39.1414 21.3586 35 16.25 35C11.1414 35 7 39.1414 7 44.25C7 49.3586 11.1414 53.5 16.25 53.5C21.3586 53.5 25.5 49.3586 25.5 44.25Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 40H16.25C13.9028 40 12 41.9028 12 44.25C12 46.5972 13.9028 48.5 16.25 48.5H55.25C57.5972 48.5 59.5 46.5972 59.5 44.25C59.5 41.9028 57.5972 40 55.25 40Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon11);
export default __webpack_public_path__ + "static/media/faq-icon11.fc2427382ceccedfbf8646eceafd2a37.svg";
export { ForwardRef as ReactComponent };